import { useEffect } from 'react'
import TagManager from 'react-gtm-module'
import { Helmet } from 'react-helmet-async'
import { useLocation, useParams } from 'react-router-dom'

export function PageTitleAndTracking({ title }: { title: string }) {
  usePageViewTracking(title)
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  )
}

function usePageViewTracking(title: string) {
  const location = useLocation()
  const { pool } = useParams()

  useEffect(() => {
    if (!title) return

    const tagManagerArgs = {
      dataLayer: {
        event: 'page_view',
        virtual_page_title: title,
        virtual_page_url: location.pathname,
        pool_name: pool,
      },
    }

    TagManager.dataLayer(tagManagerArgs)
  }, [pool])
}
